<template>
    <v-data-table :headers="headers" :items="dependencies" disable-pagination hide-default-footer sort-by="titel" dense>
        <template #item.link="{ item }">
            <a :href="urlForDependency(item)" target="_blank" :title="$t('open_in_new_tab')">
                <KpIcon icon-cls="link" color="primary" />
            </a>
        </template>
    </v-data-table>
</template>

<script setup>
import { computed } from 'vue';
import { getI18nInstance as i18n } from '@/i18n';
import { useRouter, useRoute } from 'vue-router/composables';

defineProps({
    dependencies: {
        type: Array,
        required: true,
    },
});

const route = useRoute();
const router = useRouter();

const headers = computed(() => {
    return [
        { text: i18n().t('name'), sortable: true, value: 'name' },
        { value: 'link', sortable: false, width: 50 },
    ];
});

function urlForDependency() {
    const name = 'wl_mailing_list';
    return new URL(
        router.resolve({
            name,
            params: { backRoute: { route } },
        }).href,
        window.location.origin,
    ).href;
}
</script>

<style lang="scss" scoped></style>
